import { DashboardTabModel, OldDashboardTabModel } from "./DashboardTab";
import { DashboardReportOptions } from "./DashboardReportOptions";

export interface Dashboard extends OldDashboard {
  id: number;
  title: string;
  iconClass: string;
  company: number;
  dashboardTabsJs: Array<DashboardTabModel>;
  tabsDisplay: TabsDisplay;
  companyShared: boolean;
  implementation: string;
  sortWeight: number;
  reportOptions: DashboardReportOptions;
}

export enum TabsDisplay {
  ROWS = "ROWS",
  DROPDOWN = "DROPDOWN",
}

interface OldDashboard {
  dashboardTabs: Array<OldDashboardTabModel>;
}
